import React from 'react'
import "./MobileViewProfileMenu.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser,faPaw,faLock ,faRightFromBracket} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import MobileNavbar from '../../components/Navbar/Mobile/MobileNavbar';
import { useEffect,useState } from 'react';
import MobileMiniDrawer from '../../components/MiniDrawer/MobileMiniDrawer/MobileMiniDrawer';

function MobileViewProfileMenu() {

    const [isMiniDrawerVisible, setIsMiniDrawerVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 
  
  const toggleMiniDrawer = () => {
    setIsMiniDrawerVisible(!isMiniDrawerVisible);
  };


  return (

    <div style={{ backgroundColor: "#F2F4F6"}} className="orderSummary-mobile-show">
    <div style={{ padding: "0px", margin: "0px" ,opacity: isMiniDrawerVisible ? 0.5 : 1, transition: 'opacity 0.3s'}} className='container-fluid'>
      <MobileNavbar  onToggle={toggleMiniDrawer} active="profile-menu" />
    </div>
    <div className='row p-0'>
      <div className='col-12 p-0 mobile-view-show' style={{ opacity: isMiniDrawerVisible ? 0.5 : 1, transition: 'opacity 0.3s',marginTop:"81px"}}>
       
      <div className='mobile-view-profie-menu mt-2' style={{display:"block"}}>
         <div className='profile-menu-mobile '>
         <ul className='list-unstyled m-0'>
      <li>
        <Link to="/customerProfile" style={{ color: "#6a6a6a", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px' }} /> Customer Profile
        </Link>
      </li>
      <li>
        <Link to="/petProfile" style={{ color: "#6a6a6a", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faPaw} style={{ marginRight: '10px' }} /> Pet Profile
        </Link>
      </li>
      <li>
        <Link to="/changePassword" style={{ color: "#6a6a6a", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faLock} style={{ marginRight: '10px' }} /> Change Password
        </Link>
      </li>
      <li style={{color:"#E31903"}}>
        <Link to="/logout"  style={{ color: "#E31903", textDecoration: "none" }}>
          <FontAwesomeIcon icon={faRightFromBracket} style={{ marginRight: '10px' ,color: "#E31903"}} /> Log out
        </Link>
      </li>
    </ul>
        </div>
    </div>
      </div>
      {isMiniDrawerVisible && (
        <div className='col-12'>
          <MobileMiniDrawer onClose={toggleMiniDrawer} />
        </div>
      )}
    </div>
  </div>
  )
}

export default MobileViewProfileMenu